<template>
<div>
  <!-- 半機運占い用 -->
  <form ref="trialForm"
    :action="action"
    :method="method"
    @submit.prevent="handleSubmit">
    <input type="hidden" name="_token" :value="token">
    <input v-for="(value, key) in hiddenParam" :key="key"
      type="hidden" :name="key" :value="value"
    >
    <div v-for="(field, key) in self" :key="key">
      <story-trial-input
        v-model="self[key].value"
        :name="key" :field="field"
        @input="updateInput(key, field)"
        @change="updateInput(key, field)"
      ></story-trial-input>
    </div>

    <div v-for="(field, key) in target" :key="key">
      <story-trial-input
        v-model="target[key].value"
        :name="key" :field="field"
        @input="updateInput(key, field)"
        @change="updateInput(key, field)"
      ></story-trial-input>
    </div>
  </form>
  <button class="btn u-mg-t-2"
    type="submit"
    style="width: 124px"
    data-color="primary"
    data-block="true"
    @click.prevent="handleSubmit"
  >無料で占う</button>
</div>
</template>

<script>
import mixins from './mixins'

export default {
  name: 'trial-half-period',
  mixins: [mixins],
  props: {
    hiddenParam: {
      type: Object,
      default:() => ({})
    }
  },
  data() {
    return {
      serializeArray: [],
      token: window.Laravel.csrfToken
    }
  },
  methods: {
    // Google Analyticsに無料お試し占い利用のイベントを送信
    sendEvent() {
      var name = $('.sh-recommend__topIconpic p').text(),
          counselor = ''

      switch(name) {
        case 'not for sale. Hoshi':
          counselor = 'secondHalf_form_hoshi'
          break;
        case 'クリスティーン デリコ':
          counselor = 'secondHalf_form_deriko'
          break;
        case '海龍':
          counselor = 'secondHalf_form_kairyu'
          break;
        case '島田秀平':
          counselor = 'secondHalf_form_shimada'
          break;
        case 'ステラ薫子':
          counselor = 'secondHalf_form_sutera'
          break;
        case '水晶玉子':
          counselor = 'secondHalf_form_suisho'
          break;
        case 'パシンペロンはやぶさ':
          counselor = 'secondHalf_form_hayabusa'
          break;
        case 'ルーシー・グリーン':
          counselor = 'secondHalf_form_green'
          break;
        default:
          break;
      }

      window.gtag('event', counselor, {
        custom_map: { dimension3: 'cpno' },
        cpno: window.Laravel.cpno
      })
    },
    handleSubmit() {
      this.serializeArray = $(this.$refs.trialForm).serializeArray()
      // バリデーションに通った場合submit処理
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sendEvent()
          this.$refs.trialForm.submit()
        }
      })
    }
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Trial/TrialHalfPeriod.vue